// @copyright  2025 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    // Pages
    'charitable-contribution.page.edit.title': 'Edit',
    'charitable-contribution.page.edit_draft.title': 'Edit Draft',

    // Buttons
    'charitable-contribution.button.cancel': 'Cancel',
    'charitable-contribution.button.draft': 'Save Draft',
    // Named for the action rather than its verb so a later `button.post` can carry
    // the view page's plain "Post" control without colliding with this one.
    'charitable-contribution.button.save_and_post': 'Save & Post',
    'charitable-contribution.button.save': 'Save Changes',

    // Successes
    'charitable-contribution.success.message.charitable_contribution_updated': 'Charitable contribution updated',
    'charitable-contribution.success.message.charitable_contribution_posted': 'Charitable contribution posted',

    // Errors
    'charitable-contribution.error.message.error_loading_page': 'Sorry, there was an error loading charitable contribution.| Sorry, there was an error loading charitable contributions.',
    'charitable-contribution.error.message.error_updating_charitable_contribution': 'Error updating charitable contribution',
    'charitable-contribution.error.message.error_posting_charitable_contribution': 'Error posting charitable contribution',

    // Links
    'charitable-contribution.link.retry': 'Click here to retry',
};
